import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { useLanguage } from "./LanguageContext";

import "../assets/css/footer.css";
import "../assets/css/font.css";

function Footer() {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container footer-inner">
        <span className="footer-name mono">Vinícius Gabriel © {year}</span>
        <div className="footer-socials">
          <a
            href="https://github.com/viniciuspx"
            target="_blank"
            rel="noreferrer"
            aria-label="GitHub"
          >
            <FaGithub />
          </a>
          <a
            href="https://www.linkedin.com/in/viniciuspx/"
            target="_blank"
            rel="noreferrer"
            aria-label="LinkedIn"
          >
            <FaLinkedin />
          </a>
        </div>
        <span className="footer-tagline mono">{t.footer.tagline}</span>
      </div>
    </footer>
  );
}

export default Footer;
